import { register } from 'swiper/element/bundle';
import Swiper from 'swiper';

// Register Swiper
register();

const initSliders = () => {
  const swiperContainer = document.querySelector<HTMLElement>(
    '.focus-topics__swiper',
  );

  if (swiperContainer) {
    const nextButton = swiperContainer.querySelector<HTMLElement>(
      '.custom-button-next',
    );
    const prevButton = swiperContainer.querySelector<HTMLElement>(
      '.custom-button-prev',
    );
    new Swiper(swiperContainer, {
      slidesPerView: 1.3,
      slidesPerGroup: 1,
      spaceBetween: 24,
      enabled: true,

      breakpoints: {
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 40,
        },
        1440: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 50,
        },
      },

      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
    });
  }
};

initSliders();
